// extracted by mini-css-extract-plugin
export default {"brandPromo":"lF-z","carousel":"mF-z"};